// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"74ce3508","193":"7325b5f0","206":"ea0a5461","365":"53e8686a","394":"8c8a4dc5","408":"4c026ba8","712":"b35138c1","725":"cd106b41","898":"2c44d318","988":"11b88aad"}[chunkId] + ".chunk.js";
};